import { __awaiter } from "tslib";
import { RID } from '@sharefiledev/sfplugin-resource-id';
import { RequestListNetworkError } from '../RequestListNetworkError';
import { RequestListEntityType, } from '../types';
const configuration = {
    origin: window.origin,
    apiPath: '/io/requestlist/v1/',
};
export function configureHttp(configure) {
    configure(configuration);
}
function createRequest(path, init = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = `${configuration.origin}${configuration.apiPath}${path}`;
        init.headers = Object.assign(Object.assign({}, init.headers), { 'X-BFF-CSRF': 'true' });
        return new Request(url, init);
    });
}
export const DefaultRequestListDataProvider = {
    getRequestListsByDestinationId(destinationId, paging) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchParams = new URLSearchParams();
            searchParams.append('DestinationID', destinationId);
            if (paging === null || paging === void 0 ? void 0 : paging.pageSize) {
                searchParams.append('PageSize', paging.pageSize.toString());
            }
            if (paging === null || paging === void 0 ? void 0 : paging.continuationToken) {
                searchParams.append('ContinuationToken', paging.continuationToken);
            }
            const request = yield createRequest(`lists?${searchParams}`, {
                method: 'GET',
            });
            const response = yield fetchWithError(request, 'Unable to get request lists by destination');
            const responseText = yield response.text();
            const responseJson = JSON.parse(responseText, dateReviver);
            return Object.assign(Object.assign({}, responseJson), { items: responseJson.items.map(fixRequestList) });
        });
    },
    getDeletedListsByDestinationId(destinationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchParams = new URLSearchParams();
            searchParams.append('DestinationID', destinationId);
            const request = yield createRequest(`lists/deleted?${searchParams}`, {
                method: 'GET',
            });
            const response = yield fetchWithError(request, 'Unable to get deleted request lists by destination');
            const responseText = yield response.text();
            const responseJson = JSON.parse(responseText, dateReviver);
            return Object.assign(Object.assign({}, responseJson), { items: responseJson.items.map(fixRequestList) });
        });
    },
    getRequestListsByActorId(userId, includedStates, paging) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchParams = new URLSearchParams();
            searchParams.append('ActorID', userId);
            includedStates === null || includedStates === void 0 ? void 0 : includedStates.forEach(status => {
                searchParams.append('IncludeStates', status);
            });
            if (paging === null || paging === void 0 ? void 0 : paging.pageSize) {
                searchParams.append('PageSize', paging.pageSize.toString());
            }
            if (paging === null || paging === void 0 ? void 0 : paging.continuationToken) {
                searchParams.append('ContinuationToken', paging.continuationToken);
            }
            const request = yield createRequest(`lists?${searchParams}`, { method: 'GET' });
            const response = yield fetchWithError(request, 'Unable to get request lists by actor');
            const responseText = yield response.text();
            const responseJson = JSON.parse(responseText, dateReviver);
            return Object.assign(Object.assign({}, responseJson), { items: responseJson.items.map(fixRequestList) });
        });
    },
    getRequestList(requestListId) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestListId}`, {
                method: 'GET',
            });
            const response = yield fetchWithError(request, 'Unable to get request list');
            const responseText = yield response.text();
            return fixRequestList(JSON.parse(responseText, dateReviver));
        });
    },
    createRequestList(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest('lists', {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: {
                    'content-type': 'application/json',
                },
            });
            const response = yield fetchWithError(request, 'Unable to create request list');
            const responseText = yield response.text();
            return JSON.parse(responseText, dateReviver);
        });
    },
    putRequestList(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { requestListId } = payload;
            const request = yield createRequest(`lists/${requestListId}`, {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            yield fetchWithError(request, 'Unable to update request list');
        });
    },
    addRequestListActors(requestListId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestListId}/actors`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            yield fetchWithError(request, 'Unable to add actors to request list');
        });
    },
    removeRequestListActor(requestListId, actorId) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestListId}/actors/${actorId}`, {
                method: 'DELETE',
            });
            yield fetchWithError(request, 'Unable to remove actor from request list');
        });
    },
    getRequestListFiles(requestListId) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestListId}/attachments`, {
                method: 'GET',
            });
            const response = yield fetchWithError(request, 'Unable to get files in request list');
            const responseText = yield response.text();
            return JSON.parse(responseText, dateReviver);
        });
    },
    deleteRequestList(requestListId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestListId}`, {
                method: 'DELETE',
                body: JSON.stringify(payload),
                headers: {
                    'content-type': 'application/json',
                },
            });
            yield fetchWithError(request, 'Unable to delete request list');
        });
    },
    restoreRequestList(requestListId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestListId}/restore`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            yield fetchWithError(request, 'Unable to restore request list');
        });
    },
    restoreRequestListTasks(requestListId, tasksToRestoreIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestListId}/tasks/restore`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(tasksToRestoreIds),
            });
            yield fetchWithError(request, 'Unable to restore request list tasks');
        });
    },
    startRequestList(requestListId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestListId}/activate`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            const response = yield fetchWithError(request, 'Unable to start request list');
            const responseText = yield response.text();
            return JSON.parse(responseText, dateReviver);
        });
    },
    getTasks(requestListid, requestListResourceId, includedStates, includedActorIds, paging) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchParams = new URLSearchParams();
            appendQueryParam('IncludeStates', includedStates, searchParams);
            appendQueryParam('ActorIds', includedActorIds, searchParams);
            if (paging === null || paging === void 0 ? void 0 : paging.pageSize) {
                searchParams.append('PageSize', paging.pageSize.toString());
            }
            if (paging === null || paging === void 0 ? void 0 : paging.continuationToken) {
                searchParams.append('ContinuationToken', paging.continuationToken);
            }
            const querySearchParams = searchParams.toString();
            const request = yield createRequest(`lists/${requestListid}/tasks${querySearchParams ? '?' : ''}${querySearchParams}`, {
                method: 'GET',
            });
            const response = yield fetchWithError(request, 'Unable to get tasks in request list');
            const responseText = yield response.text();
            const responseJson = JSON.parse(responseText, dateReviver);
            return Object.assign(Object.assign({}, responseJson), { items: responseJson.items.map(i => fixTask(i, requestListResourceId)) });
        });
    },
    getTask(requestListid, requestListResourceId, taskId) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestListid}/tasks/${taskId}`, {
                method: 'GET',
            });
            const response = yield fetchWithError(request, 'Unable to get task in request list');
            const responseText = yield response.text();
            const responseJson = JSON.parse(responseText, dateReviver);
            return fixTask(responseJson, requestListResourceId);
        });
    },
    createTask(requestListid, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestListid}/tasks`, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: {
                    'content-type': 'application/json',
                },
            });
            const response = yield fetchWithError(request, 'Unable to create task');
            const responseText = yield response.text();
            return JSON.parse(responseText, dateReviver);
        });
    },
    bulkCreateTasks(requestListid, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestListid}/tasks/bulk`, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: {
                    'content-type': 'application/json',
                },
            });
            yield fetchWithError(request, 'Unable to create tasks');
        });
    },
    putTask(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { requestListId, requestListTaskId } = payload;
            const request = yield createRequest(`lists/${requestListId}/tasks/${requestListTaskId}`, {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            yield fetchWithError(request, 'Unable to update task');
            return payload;
        });
    },
    addRequestListTaskActors(requestListId, requestListTaskId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestListId}/tasks/${requestListTaskId}/actors`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            yield fetchWithError(request, 'Unable to add actors to request list task');
        });
    },
    deleteRequestListTaskActor(task, userId, sendEmail) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${task.requestListId}/tasks/${task.requestListTaskId}/actors/${userId}${sendEmail ? `?sendEmail=${sendEmail}` : ''}`, {
                method: 'DELETE',
            });
            yield fetchWithError(request, 'Unable to remove actor from task');
        });
    },
    bulkUpdateDueDates(requestListId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestListId}/tasks/duedates`, {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            yield fetchWithError(request, 'Unable to bulk update due dates of tasks');
        });
    },
    submitTask(task, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { requestListId, requestListTaskId } = task;
            const request = yield createRequest(`lists/${requestListId}/tasks/${requestListTaskId}/sendforreview`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            yield fetchWithError(request, 'Unable to submit task for review');
        });
    },
    approveTask(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { requestListId, requestListTaskId } = payload;
            const request = yield createRequest(`lists/${requestListId}/tasks/${requestListTaskId}/approve`, {
                method: 'POST',
            });
            yield fetchWithError(request, 'Unable to approve task');
        });
    },
    approveTasks(requestList, tasks) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = [...tasks.map(t => t.requestListTaskId)];
            const request = yield createRequest(`lists/${requestList.requestListId}/tasks/approve`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(data),
            });
            yield fetchWithError(request, 'Unable to approve tasks');
        });
    },
    rejectTask(task, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { requestListId, requestListTaskId } = task;
            const request = yield createRequest(`lists/${requestListId}/tasks/${requestListTaskId}/reject`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            yield fetchWithError(request, 'Unable to reject task');
        });
    },
    deleteTask(task) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${task.requestListId}/tasks/${task.requestListTaskId}`, {
                method: 'DELETE',
            });
            yield fetchWithError(request, 'Unable to delete task');
        });
    },
    getTaskFiles(task) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${task.requestListId}/tasks/${task.requestListTaskId}/attachments`, {
                method: 'GET',
            });
            const response = yield fetchWithError(request, 'Unable to get files in task');
            const responseText = yield response.text();
            return JSON.parse(responseText, dateReviver);
        });
    },
    addTaskAttachment(task, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${task.requestListId}/tasks/${task.requestListTaskId}/attachments`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            const response = yield fetchWithError(request, 'Unable to add attachment to task');
            const responseText = yield response.text();
            return JSON.parse(responseText, dateReviver);
        });
    },
    updateTaskAttachment(task, attachment, attachmentItemId) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${task.requestListId}/tasks/${task.requestListTaskId}/attachments/${attachment.attachmentId}`, {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify({ attachmentItemId }),
            });
            yield fetchWithError(request, 'Unable to update attachment in task');
        });
    },
    deleteTaskAttachment(task, attachment) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${task.requestListId}/tasks/${task.requestListTaskId}/attachments/${attachment.attachmentId}`, {
                method: 'DELETE',
            });
            yield fetchWithError(request, 'Unable to delete attachment from task');
        });
    },
    bulkRestoreTaskAttachments(fileSourceStreamIdPairs) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest('attachments/restoreByStreamId', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(fileSourceStreamIdPairs),
            });
            yield fetchWithError(request, 'Unable to bulk restore attachments');
        });
    },
    bulkDeleteTaskAttachments(fileSourceStreamIdPairs) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest('attachments/deleteByStreamId', {
                method: 'DELETE',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(fileSourceStreamIdPairs),
            });
            yield fetchWithError(request, 'Unable to bulk delete attachments');
        });
    },
    completeRequestList(requestList, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestList.requestListId}/complete`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            yield fetchWithError(request, 'Unable to complete request list');
        });
    },
    reopenRequestList(requestList, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestList.requestListId}/reopen`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            yield fetchWithError(request, 'Unable to reopen request list');
        });
    },
    getDeletedTasks(requestList) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield createRequest(`lists/${requestList.requestListId}/tasks/deleted`, {
                method: 'GET',
            });
            const response = yield fetchWithError(request, 'Unable to fetch deleted tasks');
            const responseText = yield response.text();
            return JSON.parse(responseText, dateReviver);
        });
    },
};
function fetchWithError(request, errorMessage) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(request);
        if (response.status > 399) {
            const text = yield response.text();
            throw text
                ? JSON.parse(text)
                : new RequestListNetworkError(`${errorMessage} with status code ${response.status}`, response);
        }
        return response;
    });
}
function dateReviver(_key, value) {
    if (typeof value === 'string') {
        if (/^\d{4}-[01]\d-[0-3]\d(T[0-2]\d:[0-5]\d:[0-5]\d(\.\d*)?(Z|[+-]\d{2}:\d{2})?)?$/.test(value)) {
            return new Date(value);
        }
    }
    return value;
}
// todo remove after GA
function fixRequestList(requestList) {
    if (!requestList.resourceId && requestList.destinationId) {
        requestList.resourceId = RID.parse(requestList.destinationId)
            .createChild(RequestListEntityType.requestlist, requestList.requestListId)
            .toString();
    }
    return requestList;
}
// todo remove after GA
function fixTask(task, requestListResourceId) {
    if (!task.resourceId) {
        task.resourceId = RID.parse(requestListResourceId)
            .createChild(RequestListEntityType.item, task.requestListTaskId)
            .toString();
    }
    return task;
}
function appendQueryParam(name, values, params) {
    if (!values) {
        return;
    }
    if (Array.isArray(values)) {
        values.forEach(value => {
            params.append(name, value);
        });
    }
    else {
        params.append(name, values);
    }
}
//# sourceMappingURL=DefaultRequestListDataProvider.js.map